import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/messaging/constants';
import type { MessageApi } from '@/modules/messaging/types';
import type { ApiQueryParameters } from '@/types/utils/parameters';

import { messagingQueryKeys } from './queryKeys';

export type ThreadMessagesParamsApi = ApiQueryParameters<
  typeof endpoints.threadMessages
> & {
  threadId: string;
};

export const useThreadMessagesQuery = (
  { threadId, statuses }: ThreadMessagesParamsApi,
  options?: Omit<
    UseQueryOptions<MessageApi[] | undefined, unknown>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    queryKey: messagingQueryKeys.threadMessages(threadId),
    queryFn: async () => {
      const { data } = await fetchClient.GET(endpoints.threadMessages, {
        params: {
          path: {
            threadId,
          },
          query: {
            statuses,
          },
        },
      });
      return data;
    },
    ...options,
  });
};
